export default __webpack_public_path__ + "static/media/user.30e4a84b.svg";